export default "__VITE_ASSET__CqIGDqsR__"